/* eslint-disable functional/immutable-data */
/* eslint-disable max-lines-per-function */
import React, { useEffect } from 'react'
import {
  Paper,
  CircularProgress,
} from '@mui/material'
import { CommentDataProps } from '~/features/Dispatch/stores/DispatchCommentState'
import { State, useHookstate } from '@hookstate/core'
import useUserState from '~/features/User/stores/UserState'
import CommentList from './components/CommentList'
import type IUser from '~/features/User/interfaces/IUser'
import { saveCommentSortingSettings } from './services'

interface DisplayCommentsProps {
  readonly comments: State<readonly CommentDataProps[]>
  readonly commentIsCompressed: State<boolean>
  readonly isEdit?: boolean
  readonly readonly?: boolean
  readonly isDispatch?: boolean
  readonly isOccurrence?: boolean
  readonly moveScrolltoComment?: boolean
  readonly loading?: boolean
  readonly refresh?: boolean
  readonly refreshAction: () => void
  readonly dispatchCode?: string
}

export function DisplayComments({
  comments,
  isEdit = false,
  isDispatch = false,
  isOccurrence = false,
  readonly = false,
  moveScrolltoComment,
  loading,
  refresh = false,
  refreshAction,
  dispatchCode = '',
}: DisplayCommentsProps) {
  const { user: userSession } = useUserState()
  const orderSetting = userSession()
    ?.settings.get()
    .find((item) => item.name === 'order_of_comments')
  const settingName = orderSetting?.name
  const initialOrder = orderSetting?.value === 'DESC' ? true : false
  const sortComments = useHookstate(initialOrder)
  const showSortButton = useHookstate(false)
  const userSettingsLocalStorage = useHookstate<IUser | null>(null)

  useEffect(() => {
    getUserSettingsFromLocalStorage()
  }, [])

  const getUserSettingsFromLocalStorage = () => {
    const userStr = localStorage.getItem('@Despacho:user')
    userSettingsLocalStorage.set(userStr ? JSON.parse(userStr) : null)

    if (userSettingsLocalStorage.get()) {
      const setting = userSettingsLocalStorage
        .get()
        ?.settings?.find((item) => item.name === 'order_of_comments')
      sortComments.set(setting?.value === 'DESC')
    }
  }

  const handleSortComments = async () => {
    sortComments.set(!sortComments.get())

    if (settingName) {
      try {
        const data = await saveCommentSortingSettings({
          settingId: orderSetting?.setting_id,
          value: sortComments.get() ? 'DESC' : 'ASC',
        })

        if (userSettingsLocalStorage.get()) {
          if (
            userSettingsLocalStorage.get()?.settings &&
            Array.isArray(userSettingsLocalStorage.get()?.settings)
          ) {
            const currentUser = JSON.parse(
              JSON.stringify(userSettingsLocalStorage.get())
            )
            const updatedSettings =
              currentUser?.settings?.map((setting) =>
                setting.name === 'order_of_comments' ? data : setting
              ) || []

            userSettingsLocalStorage.merge({
              ...currentUser,
              settings: updatedSettings,
            })

            localStorage.setItem(
              '@Despacho:user',
              JSON.stringify(userSettingsLocalStorage.get())
            )
          }
        }
      } catch (error) {
        console.error('Erro ao salvar configuração de ordenação', error)
      }
    }
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        width: '100%',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
      onMouseEnter={() => {
        showSortButton.set(true)
      }}
      onMouseLeave={() => showSortButton.set(false)}
    >
      {loading ? (
        <CircularProgress
          sx={{ marginLeft: '0%', marginTop: '50%' }}
          disableShrink
        />
      ) : (
        <CommentList
          comments={comments}
          isEdit={isEdit}
          isDispatch={isDispatch}
          isOccurrence={isOccurrence}
          readonly={readonly}
          moveScrolltoComment={moveScrolltoComment}
          dispatchCode={dispatchCode}
          refresh={refresh}
          showSortButton={showSortButton.get()}
          sortComments={sortComments}
          handleSortComments={handleSortComments}
          refreshAction={refreshAction}
        />
      )}
    </Paper>
  )
}
